import { MetadataRoute } from 'next';

import { adjustPathname, getUrlOrigin } from '@monoimin/utils/helpers';

import { getModifiedDate, getModifiedDateType } from './getModifiedDate';

import type { Locales } from '@monoimin/sb-types';

export const createSitemapItem = (
  url: string,
  date?: getModifiedDateType,
  locale?: Locales | undefined,
  site?: MiniSlug
): MetadataRoute.Sitemap[number] => {
  return {
    url: getUrlOrigin(locale, site) + adjustPathname(url),
    lastModified: getModifiedDate(date),
  };
};

export default createSitemapItem;
